"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerNames = void 0;
/**
 * AI服务名称
 */
var ServerNames;
(function (ServerNames) {
    ServerNames["ollama"] = "ollama-server";
    ServerNames["agnet"] = "coda-agnet-server";
})(ServerNames || (exports.ServerNames = ServerNames = {}));
